import React from "react";
import { VMBuilder } from "../../../../commons/base/providers/builder";
import AdjustmentFormsTransferViewModel from "../view_models/adjustment_forms_transfer_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faPencil,
    faTrash,
    faTrashRestore,
    faX,
} from "@fortawesome/free-solid-svg-icons";
import StringUtils from "../../../../commons/utils/string_utils";
import Swal from "sweetalert2";

export default class AdjustmentFormsTransferTableWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<AdjustmentFormsTransferViewModel>>
                {(vm) => (
                    <div className="overflow-x-auto">
                        <table className="table-fixed min-w-full border-collapse text-center">
                            <thead>
                                <tr className="bg-gray-200">
                                    <th className="p-1.5 border border-gray-300 w-1/12">
                                        Kode Submit
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-2/12">
                                        Asal
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-2/12">
                                        Tujuan
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-2/12">
                                        Tanggal Dikirim
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-1/12">
                                        Telah Diterima
                                    </th>
                                    {/* <th className="p-1.5 border border-gray-300 w-1/12">
                                        Status Void
                                    </th> */}
                                    <th className="p-1.5 border border-gray-300 w-1/12">
                                        Aksi
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {vm.filteredTransferList.map((data, index) => (
                                    <tr
                                        key={index}
                                        className="odd:bg-white even:bg-gray-100 cursor-pointer text-center hover:bg-slate-200"
                                    >
                                        <td className="p-2 border border-gray-300">
                                            {data.code ?? " - "}
                                        </td>
                                        <td className="p-2 border border-gray-300">
                                            <p className="font-bold text-center">
                                                {data.fromLocation}
                                            </p>
                                            <p className="text-center">
                                                {data.senderName}
                                            </p>
                                        </td>
                                        <td className="p-2 border border-gray-300">
                                            <p className="font-bold text-center">
                                                {data.toLocation}
                                            </p>
                                            <p className="text-center">
                                                {data.receiverName}
                                            </p>
                                        </td>
                                        <td className="p-2 border border-gray-300">
                                            {StringUtils.toIndonesianDate(
                                                new Date(data.createdAt)
                                            ) ?? " - "}
                                        </td>
                                        <td className="p-2 border border-gray-300">
                                            {data.isApproved ? (
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                    className="text-green-400"
                                                />
                                            ) : (
                                                <FontAwesomeIcon
                                                    icon={faX}
                                                    className="text-red-400"
                                                />
                                            )}
                                        </td>
                                        {/* <td className="p-2 border border-gray-300">
                                            {data.isVoid ? (
                                                <div className="p-1 bg-red-400 text-white">
                                                    <span>VOID</span>
                                                </div>
                                            ) : (
                                                <div className="p-1 bg-green-400 text-white">
                                                    <span>TIDAK VOID</span>
                                                </div>
                                            )}
                                        </td> */}
                                        <td className="p-2 border border-gray-300">
                                            <button
                                                className={`mx-2 px-3 py-1 rounded-md ${
                                                    data.isApproved
                                                        ? "bg-purple-500 hover:bg-purple-700"
                                                        : "bg-gray-500"
                                                }`}
                                                onClick={() => {
                                                    if (data.isApproved) {
                                                        vm.fetchTransferDetail(
                                                            data.formId
                                                        );
                                                        vm.setFormReceivedAt(
                                                            data.createdAt
                                                        );
                                                        vm.setIsShowModal(true);
                                                    } else {
                                                        Swal.fire({
                                                            title: `Warning`,
                                                            text: `Belum Bisa Adjust Form Transfer dengan kode ${data.code} karena form tersebut belum di-approve. Pencegahan ini untuk mencegah duplikasi data`,
                                                            icon: "warning",
                                                            confirmButtonColor:
                                                                "#3085d6",
                                                            cancelButtonColor:
                                                                "#d33",
                                                            confirmButtonText:
                                                                "Ya",
                                                        });
                                                    }
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    className="text-white"
                                                    icon={faPencil}
                                                />
                                            </button>

                                            {/* <button
                                                className={`mx-2 px-3 py-1 rounded-md ${
                                                    data.isVoid
                                                        ? "bg-yellow-500 hover:bg-yellow-500"
                                                        : "bg-red-500 hover:bg-red-700"
                                                }`}
                                                onClick={() =>
                                                    vm.handleVoid({
                                                        transferId: data.formId,
                                                        transferCode: data.code,
                                                        isVoid: !data.isVoid,
                                                    })
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    className="text-white"
                                                    icon={
                                                        data.isVoid
                                                            ? faTrashRestore
                                                            : faTrash
                                                    }
                                                />
                                            </button> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
